import { EuInlineNotice } from '@newamsterdam/ui'
import type { UserCompany } from '../store/user'
import styles from './CompanyChooser.module.css'

export interface CompanyChooserProps {
  companies: UserCompany[]
  value: string
  onChange: (companyId: string) => void
  error?: string | null
  disabled?: boolean
}

export function CompanyChooser({ companies, value, onChange, error, disabled }: CompanyChooserProps) {
  return (
    <div className={styles.root}>
      <ul className={styles.list} role="radiogroup" aria-label="Lista spółek">
        {companies.map((c) => {
          const selected = value === c.id
          return (
            <li key={c.id}>
              <label
                className={selected ? `${styles.option} ${styles.optionActive}` : styles.option}
                data-active={selected}
              >
                <input
                  className={styles.radio}
                  type="radio"
                  name="company-chooser"
                  value={c.id}
                  checked={selected}
                  disabled={disabled}
                  onChange={() => onChange(c.id)}
                />
                <span className={styles.optionText}>
                  <span className={styles.optionName}>{c.name}</span>
                  <span className={styles.optionMeta}>
                    {c.code}
                    {c.currency ? ` · ${c.currency}` : ''}
                  </span>
                </span>
              </label>
            </li>
          )
        })}
      </ul>
      {error ? (
        <div className={styles.notice}>
          <EuInlineNotice tone="error">{error}</EuInlineNotice>
        </div>
      ) : null}
    </div>
  )
}
